import { useCookies } from 'react-cookie';
import { useParams } from 'react-router-dom';

const COOKIE_NAME = 'description-viewed';
const DELIMITER = ';';

const useDescriptionViewed = () => {
  const [cookies, setCookie] = useCookies([COOKIE_NAME]);
  const value = cookies[COOKIE_NAME];
  const entries = value ? value.split(DELIMITER) : [];

  const { token, number } = useParams();
  const key = `${token}:${number}`;

  const setViewed = () => {
    if (!entries.includes(key)) {
      entries.push(key);
      setCookie(COOKIE_NAME, entries.join(DELIMITER), { path: '/' });
    }
  };

  const wasViewed = entries.includes(key);

  return [
    wasViewed,
    setViewed
  ];
};

export default useDescriptionViewed;
